// extracted by mini-css-extract-plugin
export var attribution = "_b3-4";
export var authorName = "_b3-5";
export var quote = "_b3-3";
export var testimonial = "_b3-2";
export var trustedBy = "_b3-0";
export var trustedByLabel = "_b3-1";